import {
    EVENT_KINDS,
    isAnnouncement,
    toEventKind,
    type EventDto,
    type EventKind
} from '@odo/shared-ui';

// The admin-side dispatch point for `kind`: label, badge tone, and the
// authoring defaults each kind implies. A third kind is added here, not inline.

export const MEETING: EventKind = 'meeting';
export const ANNOUNCEMENT: EventKind = 'announcement';

export const EVENT_KIND_LABEL: Record<EventKind, string> = {
    meeting: 'Meeting',
    announcement: 'Announcement'
};

// Light classification badges, not SolidStatusPill: kind is what an event is,
// not what state it is in.
const EVENT_KIND_BADGE: Record<EventKind, string> = {
    meeting: 'bg-gray-100 text-gray-600',
    announcement: 'bg-[#DBEAFE] text-[#1D4ED8]'
};

// `showUntil` is derived server-side as `startsAt + durationHours`, so an
// announcement authors its end date as `startsAt` and takes the 15-min minimum.
export const ANNOUNCEMENT_DURATION_HOURS = 0.25;

/** The theme an announcement starts on; the admin may still pick another. */
export const ANNOUNCEMENT_THEME_PRESET = 'blue';

export const EVENT_KIND_OPTIONS: ReadonlyArray<{ value: EventKind; label: string }> =
    EVENT_KINDS.map((kind) => ({ value: kind, label: EVENT_KIND_LABEL[kind] }));

export { toEventKind };

/** Draft-level counterpart of shared-ui's `isAnnouncement`, which needs a DTO. */
export function isAnnouncementKind(kind: string): boolean {
    return toEventKind(kind) === ANNOUNCEMENT;
}

export function eventKindLabel(kind: string): string {
    return EVENT_KIND_LABEL[toEventKind(kind)];
}

export function eventKindBadgeClass(kind: string): string {
    return EVENT_KIND_BADGE[toEventKind(kind)];
}

/** Sign-ups, join links and confirmation emails exist only for meetings. */
export function hasSignups(event: Pick<EventDto, 'kind'>): boolean {
    return !isAnnouncement(event);
}
